// @generated by protoc-gen-es v2.4.0 with parameter "target=ts"
// @generated from file travel/v1/catalog.proto (package travel.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file travel/v1/catalog.proto.
 */
export const file_travel_v1_catalog: GenFile = /*@__PURE__*/
  fileDesc("Chd0cmF2ZWwvdjEvY2F0YWxvZy5wcm90bxIJdHJhdmVsLnYxIiYKEExpc3RDYXJkc1JlcXVlc3QSEgoKZGFwX251bWJlchgBIAEoCSI3ChFMaXN0Q2FyZHNSZXNwb25zZRIiCgVjYXJkcxgBIAMoCzITLnRyYXZlbC52MS5DYXJkVHlwZSItChdMaXN0RGlzYWJpbGl0aWVzUmVxdWVzdBISCgpkYXBfbnVtYmVyGAEgASgJIksKGExpc3REaXNhYmlsaXRpZXNSZXNwb25zZRIvCgxkaXNhYmlsaXRpZXMYASADKAsyGS50cmF2ZWwudjEuRGlzYWJpbGl0eVR5cGUiLAoWTGlzdFdoZWVsY2hhaXJzUmVxdWVzdBISCgpkYXBfbnVtYmVyGAEgASgJIkkKF0xpc3RXaGVlbGNoYWlyc1Jlc3BvbnNlEi4KC3doZWVsY2hhaXJzGAEgAygLMhkudHJhdmVsLnYxLldoZWVsY2hhaXJUeXBlIiYKCENhcmRUeXBlEgwKBGNvZGUYASABKAkSDAoEbmFtZRgCIAEoCSIsCg5EaXNhYmlsaXR5VHlwZRIMCgRjb2RlGAEgASgJEgwKBG5hbWUYAiABKAkiLAoOV2hlZWxjaGFpclR5cGUSDAoEY29kZRgBIAEoCRIMCgRuYW1lGAIgASgJMpUCCg5DYXRhbG9nU2VydmljZRJICglMaXN0Q2FyZHMSGy50cmF2ZWwudjEuTGlzdENhcmRzUmVxdWVzdBocLnRyYXZlbC52MS5MaXN0Q2FyZHNSZXNwb25zZSIAEl0KEExpc3REaXNhYmlsaXRpZXMSIi50cmF2ZWwudjEuTGlzdERpc2FiaWxpdGllc1JlcXVlc3QaIy50cmF2ZWwudjEuTGlzdERpc2FiaWxpdGllc1Jlc3BvbnNlIgASWgoPTGlzdFdoZWVsY2hhaXJzEiEudHJhdmVsLnYxLkxpc3RXaGVlbGNoYWlyc1JlcXVlc3QaIi50cmF2ZWwudjEuTGlzdFdoZWVsY2hhaXJzUmVzcG9uc2UiAGIGcHJvdG8z");

/**
 * @generated from message travel.v1.ListCardsRequest
 */
export type ListCardsRequest = Message<"travel.v1.ListCardsRequest"> & {
  /**
   * @generated from field: string dap_number = 1;
   */
  dapNumber: string;
};

/**
 * Describes the message travel.v1.ListCardsRequest.
 * Use `create(ListCardsRequestSchema)` to create a new message.
 */
export const ListCardsRequestSchema: GenMessage<ListCardsRequest> = /*@__PURE__*/
  messageDesc(file_travel_v1_catalog, 0);

/**
 * @generated from message travel.v1.ListCardsResponse
 */
export type ListCardsResponse = Message<"travel.v1.ListCardsResponse"> & {
  /**
   * @generated from field: repeated travel.v1.CardType cards = 1;
   */
  cards: CardType[];
};

/**
 * Describes the message travel.v1.ListCardsResponse.
 * Use `create(ListCardsResponseSchema)` to create a new message.
 */
export const ListCardsResponseSchema: GenMessage<ListCardsResponse> = /*@__PURE__*/
  messageDesc(file_travel_v1_catalog, 1);

/**
 * @generated from message travel.v1.ListDisabilitiesRequest
 */
export type ListDisabilitiesRequest = Message<"travel.v1.ListDisabilitiesRequest"> & {
  /**
   * @generated from field: string dap_number = 1;
   */
  dapNumber: string;
};

/**
 * Describes the message travel.v1.ListDisabilitiesRequest.
 * Use `create(ListDisabilitiesRequestSchema)` to create a new message.
 */
export const ListDisabilitiesRequestSchema: GenMessage<ListDisabilitiesRequest> = /*@__PURE__*/
  messageDesc(file_travel_v1_catalog, 2);

/**
 * @generated from message travel.v1.ListDisabilitiesResponse
 */
export type ListDisabilitiesResponse = Message<"travel.v1.ListDisabilitiesResponse"> & {
  /**
   * @generated from field: repeated travel.v1.DisabilityType disabilities = 1;
   */
  disabilities: DisabilityType[];
};

/**
 * Describes the message travel.v1.ListDisabilitiesResponse.
 * Use `create(ListDisabilitiesResponseSchema)` to create a new message.
 */
export const ListDisabilitiesResponseSchema: GenMessage<ListDisabilitiesResponse> = /*@__PURE__*/
  messageDesc(file_travel_v1_catalog, 3);

/**
 * @generated from message travel.v1.ListWheelchairsRequest
 */
export type ListWheelchairsRequest = Message<"travel.v1.ListWheelchairsRequest"> & {
  /**
   * @generated from field: string dap_number = 1;
   */
  dapNumber: string;
};

/**
 * Describes the message travel.v1.ListWheelchairsRequest.
 * Use `create(ListWheelchairsRequestSchema)` to create a new message.
 */
export const ListWheelchairsRequestSchema: GenMessage<ListWheelchairsRequest> = /*@__PURE__*/
  messageDesc(file_travel_v1_catalog, 4);

/**
 * @generated from message travel.v1.ListWheelchairsResponse
 */
export type ListWheelchairsResponse = Message<"travel.v1.ListWheelchairsResponse"> & {
  /**
   * @generated from field: repeated travel.v1.WheelchairType wheelchairs = 1;
   */
  wheelchairs: WheelchairType[];
};

/**
 * Describes the message travel.v1.ListWheelchairsResponse.
 * Use `create(ListWheelchairsResponseSchema)` to create a new message.
 */
export const ListWheelchairsResponseSchema: GenMessage<ListWheelchairsResponse> = /*@__PURE__*/
  messageDesc(file_travel_v1_catalog, 5);

/**
 * @generated from message travel.v1.CardType
 */
export type CardType = Message<"travel.v1.CardType"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message travel.v1.CardType.
 * Use `create(CardTypeSchema)` to create a new message.
 */
export const CardTypeSchema: GenMessage<CardType> = /*@__PURE__*/
  messageDesc(file_travel_v1_catalog, 6);

/**
 * @generated from message travel.v1.DisabilityType
 */
export type DisabilityType = Message<"travel.v1.DisabilityType"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message travel.v1.DisabilityType.
 * Use `create(DisabilityTypeSchema)` to create a new message.
 */
export const DisabilityTypeSchema: GenMessage<DisabilityType> = /*@__PURE__*/
  messageDesc(file_travel_v1_catalog, 7);

/**
 * @generated from message travel.v1.WheelchairType
 */
export type WheelchairType = Message<"travel.v1.WheelchairType"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message travel.v1.WheelchairType.
 * Use `create(WheelchairTypeSchema)` to create a new message.
 */
export const WheelchairTypeSchema: GenMessage<WheelchairType> = /*@__PURE__*/
  messageDesc(file_travel_v1_catalog, 8);

/**
 * @generated from service travel.v1.CatalogService
 */
export const CatalogService: GenService<{
  /**
   * @generated from rpc travel.v1.CatalogService.ListCards
   */
  listCards: {
    methodKind: "unary";
    input: typeof ListCardsRequestSchema;
    output: typeof ListCardsResponseSchema;
  },
  /**
   * @generated from rpc travel.v1.CatalogService.ListDisabilities
   */
  listDisabilities: {
    methodKind: "unary";
    input: typeof ListDisabilitiesRequestSchema;
    output: typeof ListDisabilitiesResponseSchema;
  },
  /**
   * @generated from rpc travel.v1.CatalogService.ListWheelchairs
   */
  listWheelchairs: {
    methodKind: "unary";
    input: typeof ListWheelchairsRequestSchema;
    output: typeof ListWheelchairsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_travel_v1_catalog, 0);

